<template lang="pug">
  h1.logo
    router-link(:to="brand.url")
      img(:src="`${publicPath + brand.logo}`", :alt="brand.title", :width="brand.width", :height="brand.height")

</template>

<script>
  export default  {
    name: 'logo',
    computed: {
      publicPath(){
        return process.env.BASE_URL
      }
    },
    props: {
      brand: {
        type: Object,
      }
    }
  }
</script>

<style scoped lang="scss">
  .logo {
    margin: 0;
    padding: 0;
    a{
      display: block;

    }
    img{
      display: block;
      padding-right: 0.5rem;
      padding-left: 0.5rem;
      max-height: 45px;
      object-fit: contain;
      max-width: none;
      @media (max-width: 800px){
        max-height: 30px;
        padding-left: 0.1rem;
        padding-right: 0.1rem;
      }
    }
  }
</style>
